import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import BuyTicketItem from '../BuyTicketItem/BuyTicketItem';
import BuyGroupItem from '../BuyGroupItem/BuyGroupItem';
import styles from './styles.module.css';
import { TicketInfo } from 'types';

/**
 * 券種表示リスト
 */
type BuyTicketListProps = {
    ticketList?: TicketInfo[];
    groupTicketList?: TicketInfo[];
    isLoading?: boolean;
};

const BuyTicketList = memo(({ ticketList = [], groupTicketList = [], isLoading }: BuyTicketListProps) => {
    const { t } = useTranslation();
    const isDisplayTicketInGroup = false; //後で切り替えられるようにする際に、これを環境変数に置き換えられるように

    const tickets = ticketList ?? [];

    const displayTicketList = useMemo(() => {
        if (isDisplayTicketInGroup) {
            return tickets;
        }
        const ticketInGroup = groupTicketList.reduce((init: number[], group: TicketInfo) => {
            if (!group.salesTicketIds) {
                return [...init];
            }
            return [...init, ...group.salesTicketIds];
        }, []);
        return tickets.filter((ticket) => !ticketInGroup.includes(ticket.salesTicketId));
    }, [isDisplayTicketInGroup, groupTicketList, tickets]);

    return (
        <div className={styles.ticketsContainer}>
            {tickets.length > 0 || groupTicketList.length > 0 ? (
                <>
                    {groupTicketList.map((group, index) => (
                        <BuyGroupItem key={index} group={group} />
                    ))}
                    {displayTicketList.map((ticket, index) => (
                        <BuyTicketItem key={index} ticket={ticket} />
                    ))}
                </>
            ) : (
                <p className={styles.noData}>
                    {isLoading ? t('loading.small-bought-ticket-list') : t('tickets.error-no-ticket')}
                </p>
            )}
        </div>
    );
});

export default BuyTicketList;
